{
  "metadata": {
    "id": "carbonfox-light",
    "name": "Carbonfox",
    "description": "Портировано из темы «Carbonfox» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "carbonfox.json",
      "project": "EdenEast",
      "url": "https://github.com/EdenEast/nightfox.nvim",
      "upstreamFile": "packages/ui/src/theme/themes/carbonfox.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 24.1,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.461,
      "paletteMaxS": 0.517,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": true,
      "syntaxMinDeltaE": 18.8,
      "syntaxVsTextMinDeltaE": 5.0,
      "chartsMinDeltaE": 24.3,
      "textSeparationDeltaE": 10.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "light",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#004576",
      "hover": "#1f5b86",
      "active": "#336a91",
      "foreground": "#ffffff",
      "muted": "#00457680",
      "emphasis": "#004576"
    },
    "surface": {
      "background": "#8e8e8e",
      "foreground": "#111111",
      "muted": "#bababa",
      "mutedForeground": "#262626",
      "elevated": "#d1d1d1",
      "elevatedForeground": "#161616",
      "raised": "#eeeeee",
      "raisedForeground": "#161616",
      "overlay": "#8e8e8ecc",
      "subtle": "#a4a4a4"
    },
    "interactive": {
      "border": "#707070",
      "borderHover": "#6c6c6c",
      "borderFocus": "#004576",
      "selection": "#16161629",
      "selectionForeground": "#161616",
      "focus": "#00457659",
      "focusRing": "#00457661",
      "cursor": "#161616",
      "hover": "#1616161c",
      "active": "#16161629"
    },
    "status": {
      "error": "#4f0b0e",
      "errorForeground": "#ffffff",
      "errorBackground": "#4f0b0e24",
      "errorBorder": "#4f0b0e73",
      "warning": "#2e2403",
      "warningForeground": "#ffffff",
      "warningBackground": "#2e240324",
      "warningBorder": "#2e240373",
      "success": "#082b13",
      "successForeground": "#ffffff",
      "successBackground": "#082b1324",
      "successBorder": "#082b1373",
      "info": "#002063",
      "infoForeground": "#ffffff",
      "infoBackground": "#00206324",
      "infoBorder": "#00206373"
    },
    "pr": {
      "open": "#082b13",
      "draft": "#262626",
      "blocked": "#2e2403",
      "merged": "#851218",
      "closed": "#4f0b0e"
    },
    "syntax": {
      "base": {
        "background": "#bababa",
        "foreground": "#161616",
        "comment": "#494949",
        "keyword": "#5703d7",
        "string": "#115525",
        "number": "#92141b",
        "function": "#003cba",
        "variable": "#161616",
        "type": "#614300",
        "operator": "#202020"
      },
      "tokens": {
        "commentDoc": "#494949",
        "stringEscape": "#202020",
        "keywordImport": "#5703d7",
        "storageModifier": "#5703d7",
        "functionCall": "#003cba",
        "method": "#003cba",
        "variableProperty": "#003cba",
        "variableOther": "#161616",
        "variableGlobal": "#92141b",
        "variableLocal": "#202020",
        "parameter": "#161616",
        "constant": "#92141b",
        "class": "#614300",
        "className": "#614300",
        "interface": "#614300",
        "struct": "#614300",
        "enum": "#614300",
        "typeParameter": "#614300",
        "namespace": "#614300",
        "module": "#5703d7",
        "tag": "#5703d7",
        "jsxTag": "#5703d7",
        "tagAttribute": "#003cba",
        "tagAttributeValue": "#115525",
        "boolean": "#92141b",
        "decorator": "#5703d7",
        "label": "#003cba",
        "regexp": "#115525"
      }
    },
    "charts": {
      "series": [
        "#004576",
        "#002063",
        "#082b13",
        "#4c5405",
        "#4f0b0e"
      ]
    },
    "chat": {
      "background": "#8e8e8e",
      "userMessage": "#161616",
      "userMessageBackground": "#d1d1d1",
      "assistantMessage": "#161616",
      "assistantMessageBackground": "#bababa",
      "timestamp": "#262626",
      "divider": "#707070",
      "typing": "#262626"
    },
    "loading": {
      "spinner": "#004576",
      "spinnerTrack": "#bababa",
      "skeleton": "#bababa",
      "shimmer": "#b0b0b0"
    },
    "tools": {
      "background": "#bababa",
      "border": "#707070",
      "headerHover": "#b2b2b2",
      "icon": "#004576",
      "title": "#161616",
      "description": "#262626",
      "edit": {
        "added": "#082b13",
        "addedBackground": "#082b1324",
        "removed": "#4f0b0e",
        "removedBackground": "#4f0b0e24",
        "modified": "#002063",
        "modifiedBackground": "#00206324",
        "lineNumber": "#262626"
      }
    },
    "markdown": {
      "heading1": "#161616",
      "heading2": "#161616",
      "heading3": "#161616",
      "heading4": "#161616",
      "link": "#002743",
      "linkHover": "#0e283b",
      "inlineCode": "#115525",
      "inlineCodeBackground": "#bababa",
      "blockquote": "#262626",
      "blockquoteBorder": "#707070",
      "listMarker": "#004271",
      "bold": "#161616",
      "italic": "#161616e6",
      "strikethrough": "#262626",
      "hr": "#707070"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#cd8f86",
        "foreground": "#000000",
        "contrast": 7.87
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#bf5b43",
        "foreground": "#000000",
        "contrast": 4.79
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c28f4b",
        "foreground": "#000000",
        "contrast": 7.32
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d2cf8e",
        "foreground": "#000000",
        "contrast": 13.06
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#a5ce65",
        "foreground": "#000000",
        "contrast": 11.62
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#53c550",
        "foreground": "#000000",
        "contrast": 9.47
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#69c27c",
        "foreground": "#000000",
        "contrast": 9.61
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#88d9bd",
        "foreground": "#000000",
        "contrast": 12.71
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#52b4c3",
        "foreground": "#000000",
        "contrast": 8.68
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4584be",
        "foreground": "#000000",
        "contrast": 5.3
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#465db1",
        "foreground": "#ffffff",
        "contrast": 6.07
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#5541b9",
        "foreground": "#ffffff",
        "contrast": 7.39
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a285cb",
        "foreground": "#000000",
        "contrast": 6.75
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b849be",
        "foreground": "#000000",
        "contrast": 4.73
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#b54d8d",
        "foreground": "#ffffff",
        "contrast": 4.76
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#cd86aa",
        "foreground": "#000000",
        "contrast": 7.59
      }
    ]
  }
}
